import React, { useState } from "react";
import axios from "axios";

function AddNewPerformanceData() {
  const [formData, setFormData] = useState({
    fiscal_year: "",
    total_installed_capacity: "",
    hydro_power_mw: "",
    coal_power_mw: "",
    gas_power_mw: "",
    solar_power_mw: "",
    renewable_power_mw: "",
    hydro_power_mu: "",
    coal_power_mu: "",
    gas_power_mu: "",
    total_generated_mu: "",
    non_conventional_energy_mw: "",
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  // ✅ Handle Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // ✅ Validation
  const validate = () => {
    const tempErrors = {};
    let isValid = true;

    Object.entries(formData).forEach(([key, value]) => {
      if (!value.trim()) {
        tempErrors[key] = `${key.replace(/_/g, " ")} is required.`;
        isValid = false;
      } else if (key !== "fiscal_year" && isNaN(value)) {
        tempErrors[key] = `Enter numeric value for ${key.replace(/_/g, " ")}.`;
        isValid = false;
      }
    });

    setErrors(tempErrors);
    return isValid;
  };

  // ✅ Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      await axios.post("https://backend-zkgn.onrender.com/api/performance-data", formData);

      setSuccessMessage("Performance Data added successfully!");
      setFormData({
        fiscal_year: "",
        total_installed_capacity: "",
        hydro_power_mw: "",
        coal_power_mw: "",
        gas_power_mw: "",
        solar_power_mw: "",
        renewable_power_mw: "",
        hydro_power_mu: "",
        coal_power_mu: "",
        gas_power_mu: "",
        total_generated_mu: "",
        non_conventional_energy_mw: "",
      });

      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (error) {
      console.error("Error adding performance data", error);
    }
  };

  return (
    <div className="container my-5">
      <h4 className="mb-4 text-center">Add New Performance Data</h4>

      {successMessage && (
        <div className="alert alert-success text-center" role="alert">
          {successMessage}
        </div>
      )}

      <form onSubmit={handleSubmit} className="shadow p-4 rounded bg-light">
        <div className="row g-3">
          {/* Fiscal Year */}
          <div className="col-md-6">
            <label className="form-label">Fiscal Year</label>
            <input
              type="text"
              className="form-control"
              name="fiscal_year"
              value={formData.fiscal_year}
              onChange={handleChange}
            />
            {errors.fiscal_year && (
              <small className="text-danger">{errors.fiscal_year}</small>
            )}
          </div>

          {[
            ["total_installed_capacity", "Total Installed Capacity (MW)"],
            ["hydro_power_mw", "Hydro Power (MW)"],
            ["coal_power_mw", "Coal Power (MW)"],
            ["gas_power_mw", "Gas Power (MW)"],
            ["solar_power_mw", "Solar Power (MW)"],
            ["renewable_power_mw", "Renewable Power (MW)"],
            ["hydro_power_mu", "Hydro Power (MU)"],
            ["coal_power_mu", "Coal Power (MU)"],
            ["gas_power_mu", "Gas Power (MU)"],
            ["total_generated_mu", "Total Generated (MU)"],
            ["non_conventional_energy_mw", "Non Conventional Energy (MW)"],
          ].map(([key, label]) => (
            <div className="col-md-6" key={key}>
              <label className="form-label">{label}</label>
              <input
                type="text"
                className="form-control"
                name={key}
                value={formData[key]}
                onChange={handleChange}
              />
              {errors[key] && (
                <small className="text-danger">{errors[key]}</small>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-4">
          <button type="submit" className="btn btn-success px-4">
            Submit Performance Data
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddNewPerformanceData;
